<template>
    <tr>
        <td>
            <Icon
             v-if="sender.default_sender === '1'"
             icon-class="ui-tag-01" 
             size="5"
             color="green"
             :tooltip="t('settings-connections-common-set_default')"
             />
            <Button
             v-else
             @click.prevent.stop="setAsDefault"
             style="cursor: pointer; background: none; border: none; padding: 0; margin: 0;"
             >
                <Icon
                icon-class="ui-tag-01" 
                size="3"
                color="gray"
                :tooltip="t('settings-connections-common-set_default')"
                style="opacity: 0.5;"
                />
            </Button>
        </td>
        <td @click="$emit('click', sender)">
            <img 
            :src="'/images/senders/'+sender.sender_name+'.png'" 
            :alt="t('settings-connections-channels-whatsapp')" 
            class="icon"
            height="20"
            />
            {{ sender.sender_name }}
        </td>
        <td @click="$emit('click', sender)">{{ sender.alias }}</td>
        <td @click="$emit('click', sender)">
            <span class="badge badge-warning" v-if="connectionError">
                <span class="fas fa-exclamation-triangle"></span>
                <span>{{ t('settings-connections-common-corrupted_instance') }}</span>
            </span>
            <span class="badge badge-warning" v-else-if="isConnected === null">{{ t('settings-connections-common-loading') }}</span>
            <span class="badge badge-success" v-else-if="isConnected">{{ t('settings-connections-common-connected') }}</span>
            <span class="badge badge-danger" v-else-if="!isConnected">{{ t('settings-connections-common-disconnected') }}</span>
        </td>
        <td @click="$emit('click', sender)">{{ phone || t('settings-connections-common-not_available') }}</td>
        <td @click="$emit('click', sender)">
            <span class="badge d-flex align-items-center badge-warning" v-if="connectionError">
                <span class="fas fa-exclamation-triangle"></span>
                <span>{{ t('settings-connections-common-corrupted_instance') }}</span>
                <Icon icon-class="ui-message-question-square" class="ml-2" size="2" :tooltip="t('settings-connections-common-corrupted_instance_tooltip')" />
            </span>
            <span
                class="badge badge-success"
                v-else-if="webhookStatus === 'success'"
                style="cursor: pointer;"
                @click.prevent.stop="openWebhooks"
            >
                {{ t('settings-connections-common-active') }}
            </span>
            <span
                class="badge d-flex align-items-center badge-warning"
                v-else-if="webhookStatus === 'pending'"
                style="cursor: pointer;"
                @click.prevent.stop="openWebhooks"
            >
                {{ t('settings-connections-common-not_configured') }}
                <Icon icon-class="ui-message-question-square" class="ml-2" size="2" :tooltip="t('settings-connections-common-webhook_pending_tooltip')"/>
            </span>
            <span
                class="badge d-flex align-items-center badge-danger"
                v-else-if="webhookStatus === 'error'"
                style="cursor: pointer;"
                @click.prevent.stop="openWebhooks"
            >
                {{ t('settings-connections-common-error') }}
                <Icon icon-class="ui-message-question-square" class="ml-2" size="2" :tooltip="t('settings-connections-common-webhook_error_tooltip')" />
            </span>
            <span
                class="badge d-flex align-items-center"
                v-else-if="webhookStatus === 'unknown'"
                style="cursor: pointer;"
                @click.prevent.stop="openWebhooks"
            >
                {{ t('settings-connections-common-unknown') }}
                <Icon icon-class="ui-message-question-square" class="ml-2" size="2" :tooltip="t('settings-connections-common-webhook_unknown_tooltip')" />
            </span>
            <span
                class="badge d-flex align-items-center"
                v-else-if="webhookStatus === 'unavailable'"
                style="cursor: pointer;"
                @click.prevent.stop="openWebhooks"
            >
                {{ t('settings-connections-common-unavailable') }}
                <Icon icon-class="ui-message-question-square" class="ml-2" size="2" :tooltip="t('settings-connections-common-webhook_unavailable_tooltip')" />
            </span>
            <div 
                class="text-muted small" 
                v-if="sender.webhook_url && webhookStatus !== 'success'"
                @click.stop="copyWebhookUrl"
                style="cursor: pointer; text-decoration: underline;"
            >
                {{ t('settings-connections-common-copied_url') }}
            </div>
        </td>
        <td @click="isGlobalAdmin ? null : $emit('click', sender)">
            <span v-if="savingPrice === sender.id">
                <span class="fa fa-spinner fa-spin"></span>
            </span>
            <input
                v-else-if="isGlobalAdmin"
                type="number"
                class="form-control form-control-sm"
                step="0.01"
                min="0"
                style="width: 100px"
                :value="sender.sender_price"
                @change="$emit('update-price', sender, $event.target.value)"
            />
            <span v-else>{{ currencySymbol }} {{ sender.sender_price || t('settings-connections-common-not_available') }}</span>
        </td>
        <td @click="isGlobalAdmin ? null : $emit('click', sender)">
            <span v-if="savingCreditsCost === sender.id">
                <span class="fa fa-spinner fa-spin"></span>
            </span>
            <input
                v-else-if="isGlobalAdmin"
                type="number"
                class="form-control form-control-sm"
                step="0.01"
                min="0"
                style="width: 100px"
                :value="sender.credits_cost"
                @change="$emit('update-credits-cost', sender, $event.target.value)"
            />
            <span v-else>{{ sender.credits_cost }} {{ t('settings-connections-common-credits_suffix') }}</span>
        </td>
        <td class="text-right">
            <Dropdown
                :options="commands"
                v-model="selectedCommand"
                :placeholder="t('settings-connections-table-actions')"
                style="display:inline-block; min-width:120px; vertical-align:middle;"
            >
                <template #trigger="{ label }">
                    <button class="btn btn-default" type="button" aria-haspopup="true">
                        <span class="far fa fa-ellipsis-v"></span>
                        <span class="ml-2">{{ label }}</span>
                    </button>
                </template>
            </Dropdown>
        </td>
    </tr>
</template>
<script>
import keviApi from '../../../keviApi';
import currencyMixin from '../../../mixins/currency-mixin';

export default {
    name: 'whatsapp-row',
    mixins: [currencyMixin],
    props: {
        sender: {
            type: Object,
            required: true,
        },
        isGlobalAdmin: {
            type: Boolean,
            default: false,
        },
        savingPrice: {
            default: null,
        },
        savingCreditsCost: {
            default: null,
        },
    },
    data() {
        return {
            isConnected: null,
            phone: null,
            selectedCommand: null,
            connectionError: "",
            webhookStatus: null,
        };
    },
    mounted() {
        this.checkConnectionStatus();
    },
    computed: {
        commands() {
            if (!this?.sender?.commands) {
                return [];
            }
            return Object.values(this?.sender?.commands)?.map((command) => ({
                label: this.$_(
                    `notifications-senders-commands-${command.command}-title`,
                    null,
                    command.name || command.command,
                ),
                value: command.command,
            })) || [];
        },
    },
    methods: {
        checkConnectionStatus() {
            this.isConnected = null;
            this.phone = null;
            var options = keviApi.getOptions("senders/whatsapp/is-connected/" + this.sender.id);
            this.$http(options).then((result) => {
                this.isConnected = result.data.is_connected;
                this.phone = result.data.phone_number;
                this.webhookStatus = result.data.webhook_status;
                this.connectionError = "";
            }).catch((error) => {
                console.log(error);
                this.connectionError = "connection-error";
            })
        },   
        executeCommand(command) {
            this.$emit('execute-command', command);
        },
        async copyWebhookUrl(event) {
            event.stopPropagation();
            try {
                await navigator.clipboard.writeText(this.sender.webhook_url);
                this.$store.dispatch("notification/success", {
                    text: this.$_('settings-connections-common-copied_success'),
                    duration: 3000,
                });
            } catch (error) {
                // Fallback for older browsers
                const textArea = document.createElement("textarea");
                textArea.value = this.sender.webhook_url;
                textArea.style.position = "fixed";
                textArea.style.opacity = "0";
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    document.execCommand("copy");
                    this.$store.dispatch("notification/success", {
                        text: this.$_('settings-connections-common-copied_success'),
                        duration: 3000,
                    });
                } catch (err) {
                    this.$store.dispatch("notification/error", {
                        text: this.$_('settings-connections-common-copy_error'),
                        duration: 3000,
                    });
                }
                document.body.removeChild(textArea);
            }
        },
        setAsDefault() {
            this.$emit('set-as-default', this.sender);
        },
        openWebhooks() {
            if (!this.sender?.id) return;
            if (this.webhookStatus === 'unavailable') return;
            this.$router.push(`/connections/${this.sender.id}/webhooks`);
        }
    },
    watch: {
        selectedCommand: {
            handler() {
                if (this.selectedCommand) {
                    this.executeCommand(this.selectedCommand);
                }
                this.selectedCommand = null;
            },
        },
        sender: {
            handler() {
                this.checkConnectionStatus();
            },
            deep: true,
        },
    },
}
</script>